import React, { useState, useEffect } from "react";
import moment from "moment";
import Select from "../wms/select";
import { getBranchList, getWoodChipReport } from "../../services/wms";
import Reporttable from "./reporttable";
import numberWithCommas from '../common/number';

const Reportwms = ({ startDate, endDate, disabled }) => {
  const [branchlist, setbranchlist] = useState([]);
  const [reportlist, setreportlist] = useState([]);
  const [branchId, setbranchId] = useState(0);
  const [data, setdate] = useState({
    totalin: 0,
    totalover: 0,
    totalavg: 0,
    totalrecieve: 0,
    c11: 0,
    c15: 0,
    c21: 0,
    c24: 0,
    c10: 0,
    c35: 0,
    c27: 0,
    c02: 0,
    c20: 0,
  });

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getBranchList();
      if (result.status === "success") {
        setbranchlist(result.data.list);
      }
    };
    loadData();
  }, []);

  useEffect(() => {
    disabled(true)
    const loadData = async () => {
      const { data: result } = await getWoodChipReport(
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        branchId
      );
      if (result) {
        setreportlist(result);
        disabled(false);
      }
    };
    loadData();
  }, [startDate, endDate, branchId]);

  useEffect(() => {
    if (reportlist && reportlist.length > 1) {
      setdate({
        totalin: reportlist[reportlist.length - 1].around,
        totalover: reportlist[reportlist.length - 1].overtime,
        totalavg: reportlist[reportlist.length - 1].avg,
        totalrecieve: reportlist[reportlist.length - 1].weighttotal,
        c11: reportlist[reportlist.length - 1].ลูกค้าไม้หน้าโรงงาน,
        c15: reportlist[reportlist.length - 1].ไม้ลานลูกค้า,
        c21: reportlist[reportlist.length - 1].ไม้เหมาแปลงแบบไร่,
        c24: reportlist[reportlist.length - 1].ไม้เหมาแปลงแบบตัน,
        c10: reportlist[reportlist.length - 1].ไม้สาขาตาชั่งHUB,
        c35: reportlist[reportlist.length - 1].ไม้สาขาหางลากน้ำหนัก,
        c27: reportlist[reportlist.length - 1].ไม้เหมาแปลงออป,
        c02: reportlist[reportlist.length - 1].ไม้สมาชิกSMT,
        c20: reportlist[reportlist.length - 1].ไม้เก็บกลับKN,
      });
      //  console.log(reportlist.length)
    }else {
      setdate({
        totalin:0,
        totalover: 0,
        totalavg: 0,
        totalrecieve: 0,
        c11: 0,
        c15:0,
        c21:0,
        c24: 0,
        c10:0,
        c35: 0,
        c27: 0,
        c02: 0,
        c20:0,
      });
    }
  }, [reportlist]);
  // console.log(reportlist)

  const handleBranchChange = (event) => {
    setbranchId(event.currentTarget.value);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 col-md-12   mt-2 mb-2 ">
            <Select
              data={branchlist}
              label="โรงชิพ"
              value={branchId}
              textProperty="name"
              valueProperty="_id"
              onChange={handleBranchChange}
            />
          </div>
          <div className="col-lg-3 col-md-12">
            <div className="col-auto mx-1 mb-3">
              <div className="card">
                <div className="card-body p-3">
                  <div className="justify-content-center
           align-items-center">
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-primary">
                          0
                        </span>
                      </h3>
                      แผนไม้ท่อนรับเข้า
                    </div>
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-success">
                          {numberWithCommas(data.totalrecieve)}
                        </span>
                      </h3>
                      ผลงาน ไม้ท่อนรับเข้า
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12">
            <div className="col-auto mx-1 mb-3">
              <div className="card">
                <div className="card-body p-3">
                  <div className="justify-content-center
           align-items-center">
                    {/* <div className="col-auto mx-2 text-center">
                  <h4 className="d-inline">Work</h4>
                </div> */}
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-warning text-dark">
                          {numberWithCommas(data.totalin)}
                        </span>
                      </h3>
                      จำนวนรถเข้าโรงงาน (คัน)
                    </div>
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-danger">
                          {data.totalover}
                        </span>
                      </h3>
                      จำนวนรถรอลงสินค้าเกิน 2 ชม.
                    </div>
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-warning text-dark">
                          {numberWithCommas(data.totalavg)}
                        </span>
                      </h3>
                      ชั่วโมงลงสินค้าเฉลี่ย ชม./คัน
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 mx-1 mb-3">
            <div className="card">
              <div className="card-body p-3">
                <div className="row justify-content-center
           align-items-center">
                  <div className="col-auto  text-center">
                    <h4 className="d-inline"> ผลงานโรงชิพ</h4>
                  </div>

                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-info text-dark">
                        {data.c11}
                      </span>
                    </h3>
                    ลูกค้าหน้าโรงงาน
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-info text-dark">
                        {numberWithCommas(data.c15)}
                      </span>
                    </h3>
                    ลานลูกค้า
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-info text-dark">
                        {numberWithCommas(data.c21)}
                      </span>
                    </h3>
                    เหมาแปลงแบบไร่
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-info text-dark">
                        {numberWithCommas(data.c24)}
                      </span>
                    </h3>
                    เหมาแปลงแบบตัน
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-info text-dark">
                        {numberWithCommas(data.c10)}
                      </span>
                    </h3>
                    สาขาตาชั่ง HUB
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-info text-dark">
                        {numberWithCommas(data.c35)}
                      </span>
                    </h3>
                    หางลากน้ำหนัก
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-info text-dark">
                        {numberWithCommas(data.c27)}
                      </span>
                    </h3>
                    ไม้ท่อน ออป.
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-info text-dark">
                        {numberWithCommas(data.c02)}
                      </span>
                    </h3>
                    ไม้ท่อน SMT
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-info text-dark">
                        {numberWithCommas(data.c20)}
                      </span>
                    </h3>
                    ไม้เก็บกลับ
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Reporttable list={reportlist} />
    </>
  );
};

export default Reportwms;
